import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-booking-devices-list',
  templateUrl: './booking-devices-list.component.html',
  styleUrls: ['./booking-devices-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingDevicesListComponent {}
